import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocuments = createSelector(
  [(store: RootState) => store.supervisorDocumentsList.documents],
  (documents) => documents
);
